import { ChangeOrderPlanOption } from "./changeorderplanoption";
import { ConstructionStatusName, ChangeOrderType, SalesStatusDescription, SalesAgreementCancellation, ChangeOrderLot } from '.';
import { ChangeOrderHanding } from './changeorderhanding';
import { ChangeOrderPlan } from './changeorderplan';

export class ChangeOrder {
    id: number;
    changeOrderTypeDescription: ChangeOrderType;
    createdBy: string;
    createdUtcDate: Date;
    lastModifiedBy: string;
    lastModifiedUtcDate: Date;
    jobChangeOrderGroupId: number;
    changeOrderPlanOptions: ChangeOrderPlanOption[];
    changeOrderHandings: ChangeOrderHanding[];
    changeOrderPlans: ChangeOrderPlan[];
    changeOrderLots: ChangeOrderLot[];
    financialPlanIntegrationKey: string;
    action: string;
    planTemplate: string;
    elevationHanding: string;
    elevationName: string;
    handingIconClass: string;
    salesAgreementCancellation: SalesAgreementCancellation;
    salesStatusDescription: SalesStatusDescription;
    salesStatusUTCDate?: Date;
    constructionStatusDescription: ConstructionStatusName;
    constructionStatusUTCDate?: Date;
    constructionStatusLastModifiedBy: string;
}